import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "result", "empty", "shortcut"]

  connect() {
    this.shortcutTargets.forEach((element) => { element.textContent = /Mac|iPhone|iPad/.test(navigator.platform) ? "⌘ K" : "Ctrl K" })
    this.onCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.onCache)
  }

  disconnect() { document.removeEventListener("turbo:before-cache", this.onCache) }

  shortcut(event) {
    if (!(event.metaKey || event.ctrlKey) || event.key.toLowerCase() !== "k" || event.altKey) return
    event.preventDefault()
    this.dialogTarget.open ? this.close() : this.open()
  }

  open() {
    this.application.getControllerForElementAndIdentifier(this.element, "sidebar")?.close()
    this.inputTarget.value = ""
    this.filter()
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close() { if (this.dialogTarget.open) this.dialogTarget.close() }
  closed() { this.inputTarget.value = ""; this.filter() }
  backdrop(event) { if (event.target === this.dialogTarget) this.close() }

  filter() {
    const normalize = (value) => value.toLocaleLowerCase().normalize("NFKD").replace(/\p{M}/gu, "").replace(/[^\p{L}\p{N}]/gu, "")
    const query = normalize(this.inputTarget.value)
    this.resultTargets.forEach((link) => { link.hidden = !normalize(link.dataset.label).includes(query) })
    this.emptyTarget.hidden = this.resultTargets.some((link) => !link.hidden)
  }

  navigate(event) {
    const visible = this.resultTargets.filter((link) => !link.hidden)
    const index = visible.indexOf(document.activeElement)
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      const next = index === -1 && event.key === "ArrowUp" ? visible.length - 1 : index + (event.key === "ArrowDown" ? 1 : -1)
      if (next < 0 || next >= visible.length) this.inputTarget.focus()
      else visible[next].focus()
    }
    if (event.key === "Enter" && event.target === this.inputTarget && this.inputTarget.value.trim()) {
      event.preventDefault()
      visible[0]?.click()
    }
  }
}
